import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const EditFolder = ({
  height = 16,
  width = 16,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-test="folder-icon" height={height} width={width} viewBox="0 0 20 20" {...props}>
    <path
      d="M7.18721 15.0625H2.83496"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.1875 7.1875V4.9375C16.1875 4.63913 16.069 4.35298 15.858 4.142C15.647 3.93103 15.3609 3.8125 15.0625 3.8125H7.1875V2.6875C7.1875 2.38913 7.06897 2.10298 6.858 1.892C6.64702 1.68103 6.36087 1.5625 6.0625 1.5625H2.6875C2.38913 1.5625 2.10298 1.68103 1.892 1.892C1.68103 2.10298 1.5625 2.38913 1.5625 2.6875V13.7875C1.56673 14.0938 1.68113 14.3884 1.88476 14.6173C2.08839 14.8462 2.36764 14.9942 2.6714 15.034C2.97516 15.0739 3.28313 15.0031 3.53895 14.8345C3.79477 14.6659 3.98133 14.4109 4.0645 14.116L5.82775 8.0005C5.89544 7.76601 6.03754 7.5599 6.23262 7.41325C6.42771 7.2666 6.66519 7.18736 6.90925 7.1875H17.3125"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.9725 12.1528L12.25 17.8753L9.4375 18.4378L10 15.6253L15.7225 9.90277C15.8698 9.75527 16.0447 9.63826 16.2372 9.55843C16.4297 9.47859 16.6361 9.4375 16.8445 9.4375C17.0529 9.4375 17.2593 9.47859 17.4518 9.55843C17.6443 9.63826 17.8192 9.75527 17.9665 9.90277L17.9725 9.90877C18.12 10.056 18.237 10.2309 18.3168 10.4234C18.3967 10.616 18.4378 10.8223 18.4378 11.0308C18.4378 11.2392 18.3967 11.4456 18.3168 11.6381C18.237 11.8306 18.12 12.0055 17.9725 12.1528V12.1528Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
